export const SET_GROWTH = "setGrowth";

export const setGrowth = (payload: any) => {
  return {
    type: SET_GROWTH,
    payload,
  };
};
